export default () => {
	return localStorage.getItem('USER-TOKEN')
}
